import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {

  },
  finalize() {

    $( ".printbutton" ).on("click", function () {
      printDiv('printableArea');
    });

   function printDiv(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(true);
    }


$(".remove-listingfrom-shortlist-staff").on("click", function () {
    var lp_id = $(this).data("lp-id");
    var action="removestaff";
    var url = ajaxdta.ajaxurl + "?action=add_to_lpcart";
    
    $.ajax({
      type: "POST",
      url: url,
      data: {
        lp_id: lp_id, action:action
      },
      dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
          $("#staffmainlisting"+ lp_id).hide();            
      },
    });
  });

  $(".create-plan").on("click", function () {
        $("div.crossmark").hide();
        $("div.radiobutton").show(); 
        $("#planname").show(); 
        $("#buttonplan").show(); 
  });

  $(".remove-listing-staff").on("click", function () {
    var lp_id = $(this).data("lp-id");
    var action="removestaff";
    var url = ajaxdta.ajaxurl + "?action=add_to_lpcart";
    
    $.ajax({
      type: "POST",
      url: url,
      data: {
        lp_id: lp_id, action:action
      },
      dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
          $("#staffselected"+ lp_id).hide(); 
          $("#staffnotselected"+ lp_id).show();          
      },
    });
  });


  $(".add-listing-staff").on("click", function () {
    var lp_id = $(this).data("lp-id");
    var action="addstaff";
    var url = ajaxdta.ajaxurl + "?action=add_to_lpcart";
  
    $.ajax({
      type: "POST",
      url: url,
      data: {
        lp_id: lp_id, action:action
      },
      dataType:"JSON",
      success: function (data) { 
        var mString = data.count;  
        $("#staffnotselected"+ lp_id).hide();
        $("#staffselected"+ lp_id).show();             
      },
    });
  });

$(".cancel-plan").on("click", function () {
    $("#planname").hide(); 
    $("#buttonplan").hide(); 
});

$(".cancel-search").on("click", function () {
  $("#searchname").hide(); 
  $("#buttonsearch").hide(); 
});

$(".add-search").on("click", function () {
  $("#searchname").show(); 
  $("#buttonsearch").show(); 
});

$(".addtoplan").on("click", function () {
  var lp_id = $(this).data("lp-id");
  $("#planselect"+ lp_id).show();
});

},
};


// WEBPACK FOOTER //
// ./scripts/routes/training-plan-builder-shortlist.js